import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Okamžite resetujeme scroll na začiatok pri zmene routy
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
